import React from 'react';
import { ControlRenderer, FetchAvailable } from '../../globals/ProjectVars';
import { Testimonial } from './Testimonial';
import { TestimonialList } from './TestimonialList';
import { TestimonialSlider } from './TestimonialSlider';

export class Testimonials extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            reqFailed: false
        };

        this.testimonials;
    }

    componentDidMount() {
        this.getTestimonialData();
    }

    getTestimonialData() {
        let reqUrl = this.props.slider ? `${ControlRenderer}PromoTestimonials&Featured=true` : `${ControlRenderer}PromoTestimonials`;
        if (FetchAvailable) {
            fetch(reqUrl)
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    }
                    else {
                        return 'error';
                    }
                })
                .then((resJson) => {
                    if (resJson !== 'error') {
                        this.setState({
                            data: resJson
                        });
                    } else {
                        this.setState({
                            reqFailed: true
                        });
                    }
                });
        }
        else {
            $j.get(reqUrl, (res) => {
                this.setState({
                    data: res
                });
            }, "json")
                .fail(() => {
                    this.setState({
                        reqFailed: true
                    });
                });
        }
    }

    render() {
        if (!this.state.data) {
            if (this.state.reqFailed) {
                return (
                    <p className="alert"><span className="glyphicon glyphicon-warning-sign" aria-hidden="true" />Sorry, something went wrong.</p>
                );
            }
            else {
                return (
                    <p className="loading">Loading</p>
                );
            }
        }
        else {
            this.testimonials = this.state.data.map((testimonial) =>
                <Testimonial
                    key={testimonial.Ordinal}
                    id={testimonial.Ordinal}
                    testimonialData={testimonial}
                />
            );
            let testimonialsType = this.props.slider ?
                <TestimonialSlider
                    className='slide testimonial'
                    title={this.props.title}
                >
                    {this.testimonials}
                </TestimonialSlider> :
                <TestimonialList
                    className='col-lg-4 col-md-6 col-xs-12 testimonial'
                >
                    {this.testimonials}
                </TestimonialList>;

            return (
                <React.Fragment>{testimonialsType}</React.Fragment>
            );
        }
    }
}